"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isotopesObject = void 0;
const elementsAndIsotopesObject_js_1 = require("./elementsAndIsotopesObject.js");
exports.isotopesObject = {};
for (const [symbol, element] of Object.entries(elementsAndIsotopesObject_js_1.elementsAndIsotopesObject)) {
    if (!element)
        continue;
    for (const isotope of element.isotopes) {
        exports.isotopesObject[`${isotope.nominal}${symbol}`] = {
            abundance: isotope.abundance,
            mass: isotope.mass,
        };
    }
}
//# sourceMappingURL=isotopesObject.js.map